/* Sign-up postcard. Markup + settings: sections/signup-postcard.liquid. Styles: signup-postcard.css.

   WHEN IT SHOWS (skipped entirely in test mode, which opens it straight away)
   - Never: after a sign-up in this browser; to a browser Klaviyo already knows (arrived from a
     Klaviyo email: _kx or utm_source=klaviyo, or an identified __kla_id cookie); on excluded paths.
   - First time: the earliest of N seconds of active time on site (counted across pages in the
     session, only while the tab is visible), X% scrolled down the current page, or on desktop
     the pointer leaving through the top of the window after M seconds.
   - Closed once: hidden for close_days. After that, on the next visit it shows after
     return_after seconds. Closed twice: hidden for second_close_days, then as a return.
   - Always waits while the Pandectes cookie banner is on screen.
   Browser storage only (localStorage). Safari clears script storage after 7 days without a
   visit, so the 30-day rule can reset on iPhones; the 7-day rule is unaffected in practice.

   DATA
   - First-touch and last-touch UTMs + click ids + referrer + landing page are captured on
     every page this script loads on (stored first/last touch), and sent with the sign-up.
   - Two Klaviyo client calls: an event (metric name from settings) carrying names, country,
     locale and the attribution onto the profile, then the email subscription to the list.

   SPAM (roughly what a Klaviyo form does, no captcha)
   - Honeypot field; a submit within 2.5s of opening is treated as a bot and silently dropped;
     email format check; the button locks while sending; one sign-up per browser.
*/
(function () {
  'use strict';
  var root = document.querySelector('[data-signup-postcard]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var d = root.dataset;
  var TEST = d.test === 'true';
  var KEY = 'ph_sp', FT = 'ph_sp_ft', LT = 'ph_sp_lt', ACT = 'ph_sp_active';
  var DAY = 864e5;
  var desktop = window.matchMedia('(min-width: 750px)');
  var finePointer = window.matchMedia('(pointer: fine)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var timers = [];

  function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
  function clearTimers() { timers.forEach(clearTimeout); timers = []; }
  function get(store, k) { try { return JSON.parse(store.getItem(k) || 'null'); } catch (e) { return null; } }
  function set(store, k, v) { try { store.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function now() { return Date.now(); }

  /* ---------- attribution capture (runs on every page) ---------- */
  var params = new URLSearchParams(location.search);
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid'];
  var touch = {};
  KEYS.forEach(function (k) { if (params.get(k)) touch[k] = params.get(k).slice(0, 200); });
  var ref = document.referrer && document.referrer.indexOf(location.host) === -1 ? document.referrer.slice(0, 300) : '';
  if (Object.keys(touch).length || ref) {
    touch.landing_page = (location.pathname + location.search).slice(0, 300);
    touch.referrer = ref;
    touch.at = new Date().toISOString();
    if (!get(localStorage, FT)) set(localStorage, FT, touch);
    set(localStorage, LT, touch);
  }
  if (params.get('_kx') || (params.get('utm_source') || '').toLowerCase() === 'klaviyo') {
    try { sessionStorage.setItem('ph_sp_kl', '1'); } catch (e) {}
  }

  /* ---------- should it show at all ---------- */
  var state = get(localStorage, KEY) || { closes: 0, closedAt: 0, signedUp: false };

  function klaviyoKnows() {
    try { if (sessionStorage.getItem('ph_sp_kl')) return true; } catch (e) {}
    var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
    if (!m) return false;
    try {
      var j = JSON.parse(atob(decodeURIComponent(m[1])));
      return !!(j.$exchange_id || j.$email || j.$kx);
    } catch (e) { return false; }
  }
  function excluded() {
    var p = location.pathname;
    return (d.exclude || '').split('|').some(function (x) { x = x.trim(); return x && p.indexOf(x) !== -1; });
  }

  var returning = false;
  if (!TEST) {
    if (state.signedUp || klaviyoKnows() || excluded()) return;
    if (state.closes > 0) {
      var wait = (state.closes > 1 ? +d.close2Days : +d.closeDays) * DAY;
      if (now() - state.closedAt < wait) return;
      returning = true;
    }
  }

  /* ---------- copy: no orphans where text-wrap: pretty is unsupported ---------- */
  root.querySelectorAll('.sp__title, .sp__lede').forEach(function (el) {
    if (el.children.length) return;
    el.textContent = el.textContent.replace(/ (\S+)\s*$/, ' $1');
  });

  /* ---------- triggers ---------- */
  var active = 0;
  try { active = +sessionStorage.getItem(ACT) || 0; } catch (e) {}
  var tick = setInterval(function () {
    if (document.visibilityState !== 'visible') return;
    active += 1000;
    try { sessionStorage.setItem(ACT, String(active)); } catch (e) {}
    if (active >= (returning ? +d.returnAfter : +d.after) * 1000) fire('time');
  }, 1000);

  function onScroll() {
    if (returning) return;
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && window.scrollY / h * 100 >= +d.scroll) fire('scroll');
  }
  function onLeave(e) {
    if (e.relatedTarget || e.clientY > 0) return;
    if (!desktop.matches || !finePointer.matches || d.exit !== 'true') return;
    if (active < +d.exitAfter * 1000) return;
    fire('exit');
  }
  var fired = false, trigger = '';
  function fire(why) {
    if (fired) return;
    fired = true; trigger = why;
    clearInterval(tick);
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onLeave);
    whenBannerGone(open);
  }
  function whenBannerGone(fn) {
    var b = document.querySelector('#pandectes-banner .cc-window, #pandectes-banner');
    if (b && b.getBoundingClientRect().height > 0 && getComputedStyle(b).visibility !== 'hidden') {
      return setTimeout(function () { whenBannerGone(fn); }, 800);
    }
    fn();
  }

  if (TEST) { clearInterval(tick); setTimeout(function () { trigger = 'test'; open(); }, 700); }
  else {
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('mouseout', onLeave);
  }

  /* ---------- open / close ---------- */
  var card = root.querySelector('.sp__card');
  var tilt = root.querySelector('.sp__tilt');
  var form = root.querySelector('[data-sp-form]');
  var status = root.querySelector('.sp__status');
  var openedAt = 0, lastFocus = null, phase = 'closed';

  /* Shopify customer events: the custom pixel "Sign-up postcard -> GA4" (Settings > Customer events)
     subscribes to these and sends them to GA4 G-EDXN1WTN3K as signup_view / sign_up. Consent is
     applied by Shopify to the pixel, so nothing here reads cookies or loads gtag. */
  function publish(name, extra) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(name, Object.assign({ trigger: trigger, market: d.market, locale: d.locale, page: location.pathname }, extra || {}));
      }
    } catch (e) {}
  }

  function open() {
    if (phase !== 'closed') return;
    phase = 'in';
    lastFocus = document.activeElement;
    root.hidden = false;
    root.getBoundingClientRect();
    root.classList.add('is-in');
    document.documentElement.style.overflow = 'hidden';
    openedAt = now();
    if (desktop.matches) card.focus({ preventScroll: true });
    if (!TEST) publish('signup_postcard_view');
  }
  function hideAll() {
    root.hidden = true;
    root.className = 'sp';
    document.documentElement.style.overflow = '';
    phase = 'done';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function close() {
    if (phase === 'thanks') return lift();
    if (phase !== 'in') return;
    phase = 'out';
    root.classList.remove('is-in');
    root.classList.add('is-out');
    state.closes = (state.closes || 0) + 1;
    state.closedAt = now();
    if (!TEST) publish('signup_postcard_close', { closes: state.closes });
    if (!TEST) set(localStorage, KEY, state);
    later(hideAll, reduced ? 350 : 1150);
  }
  function lift() {
    if (phase !== 'thanks') return;
    phase = 'lift';
    clearTimers();
    root.classList.remove('is-in', 'is-thanks', 'is-stamped', 'is-card');
    root.classList.add('is-lift');
    later(hideAll, 450 + 1150);
  }
  root.querySelectorAll('[data-sp-close]').forEach(function (b) { b.addEventListener('click', close); });
  root.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* Keep Tab inside the dialog */
  card.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = [].slice.call(root.querySelectorAll('input:not([type=hidden]):not([tabindex="-1"]), button, a[href]')).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Gentle tilt under the pointer, desktop only, as on the RSVP card */
  card.addEventListener('pointermove', function (e) {
    if (phase !== 'in' || !desktop.matches || !finePointer.matches || reduced) return;
    var r = card.getBoundingClientRect();
    var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
    tilt.style.setProperty('--rx', (-y * 3).toFixed(2) + 'deg');
    tilt.style.setProperty('--ry', (x * 4).toFixed(2) + 'deg');
  });
  card.addEventListener('pointerleave', function () { tilt.style.setProperty('--rx', '0deg'); tilt.style.setProperty('--ry', '0deg'); });

  /* ---------- country: every country, autofill-friendly text field + search ---------- */
  var CODES = 'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'.split(' ');
  var OWN = { DE: 'de', AT: 'de', CH: 'de', ES: 'es', MX: 'es', IT: 'it', PT: 'pt', BR: 'pt', NL: 'nl', JP: 'ja', KR: 'ko', CN: 'zh', TW: 'zh', HK: 'zh', AE: 'ar', SA: 'ar', GR: 'el', SE: 'sv', DK: 'da', PL: 'pl', FR: 'fr', BE: 'fr' };
  var ALIAS = { GB: 'uk britain great britain england scotland wales northern ireland', US: 'usa america united states of america', AE: 'uae dubai abu dhabi', KR: 'korea', NL: 'holland', CZ: 'czech republic' };
  var lang = d.locale || 'en';
  function norm(s) { return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim(); }
  function names(l) { try { return new Intl.DisplayNames([l], { type: 'region' }); } catch (e) { return { of: function (c) { return c; } }; } }
  var shown = names(lang), english = names('en');
  var others = ['en', 'fr', 'de', 'es', 'it', 'pt', 'nl', 'ja', 'ko', 'zh', 'ar', 'ru', 'el', 'sv', 'da', 'pl'].map(names);
  var countries = CODES.map(function (code) {
    var name = shown.of(code) || code;
    var local = OWN[code] && OWN[code] !== lang ? names(OWN[code]).of(code) : '';
    if (local === name) local = '';
    var keys = [name, code, ALIAS[code] || ''].concat(others.map(function (n) { return n.of(code) || ''; })).map(norm);
    return { code: code, name: name, local: local, keys: keys };
  }).sort(function (a, b) { return a.name.localeCompare(b.name, lang); });
  var byCode = {};
  countries.forEach(function (c) { byCode[c.code] = c; });

  var cInput = form.elements.country, cCode = form.elements.country_code;
  var list = root.querySelector('.sp__sug');
  /* Browser region first (fr-FR -> FR): Shopify falls back to a market's first country (Aland for
     Europe) when it cannot place a visitor. Then Shopify's localization country. */
  var navRegion = '';
  (navigator.languages || [navigator.language || '']).some(function (l) { var m = /-([A-Za-z]{2})$/.exec(l || ''); if (m && byCode[m[1].toUpperCase()]) { navRegion = m[1].toUpperCase(); return true; } return false; });
  var homeCode = navRegion || d.country;
  var home = byCode[homeCode];
  if (home) { cInput.value = home.name; cCode.value = home.code; }
  var PINS = [homeCode, 'GB', 'FR', 'DE', 'US', 'JP'].filter(function (v, i, a) { return v && a.indexOf(v) === i && byCode[v]; });

  function match(text) {
    var q = norm(text);
    if (!q) return null;
    for (var i = 0; i < countries.length; i++) if (countries[i].keys.indexOf(q) !== -1) return countries[i];
    return null;
  }
  function row(c) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'sp__sug-o'; b.setAttribute('role', 'option');
    b.setAttribute('aria-selected', String(cCode.value === c.code));
    b.dataset.code = c.code;
    var n = document.createElement('span'); n.textContent = c.name; b.appendChild(n);
    var l = document.createElement('span'); l.className = 'sp__sug-l'; l.textContent = c.local; b.appendChild(l);
    return b;
  }
  function head(text) { var h = document.createElement('div'); h.className = 'sp__sug-h'; h.textContent = text; return h; }
  function render() {
    var q = norm(cInput.value), exact = match(cInput.value);
    list.textContent = '';
    if (!q || (exact && norm(exact.name) === q)) {
      list.appendChild(head(d.suggested));
      PINS.forEach(function (c) { list.appendChild(row(byCode[c])); });
      list.appendChild(head(d.all));
      countries.forEach(function (c) { list.appendChild(row(c)); });
    } else {
      countries.filter(function (c) {
        return c.keys.some(function (k) { return k.indexOf(q) === 0 || k.split(/[\s-]+/).some(function (w) { return w.indexOf(q) === 0; }); });
      }).forEach(function (c) { list.appendChild(row(c)); });
    }
    var any = !!list.querySelector('.sp__sug-o');
    list.hidden = !any;
    cInput.setAttribute('aria-expanded', String(any));
  }
  function closeList() { list.hidden = true; cInput.setAttribute('aria-expanded', 'false'); }
  function pick(code) { var c = byCode[code]; if (!c) return; cInput.value = c.name; cCode.value = c.code; closeList(); }

  cInput.addEventListener('focus', render);
  cInput.addEventListener('input', function () { var m = match(cInput.value); cCode.value = m ? m.code : ''; render(); });
  cInput.addEventListener('change', function () { var m = match(cInput.value); if (m) pick(m.code); }); /* autofill lands here */
  cInput.addEventListener('blur', function () { setTimeout(closeList, 150); });
  list.addEventListener('mousedown', function (e) { e.preventDefault(); }); /* scrolling the list keeps focus */
  list.addEventListener('click', function (e) { var b = e.target.closest('.sp__sug-o'); if (b) pick(b.dataset.code); });
  cInput.addEventListener('keydown', function (e) {
    var opts = [].slice.call(list.querySelectorAll('.sp__sug-o'));
    if (list.hidden || !opts.length) return;
    var i = opts.indexOf(list.querySelector('.is-active'));
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      if (i > -1) opts[i].classList.remove('is-active');
      i = e.key === 'ArrowDown' ? Math.min(i + 1, opts.length - 1) : Math.max(i - 1, 0);
      opts[i].classList.add('is-active');
      opts[i].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && i > -1) { e.preventDefault(); pick(opts[i].dataset.code); }
    else if (e.key === 'Escape') { e.stopPropagation(); closeList(); }
  });

  /* ---------- submit ---------- */
  function say(t) { status.textContent = t || ''; }
  function post(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(d.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-07-15' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(path + ' ' + r.status); return r; });
  }
  function prefixed(obj, pre) {
    var o = {};
    Object.keys(obj || {}).forEach(function (k) { if (k !== 'at') o[pre + k] = obj[k]; });
    return o;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (phase !== 'in') return;
    var f = form.elements;
    var email = f.email.value.trim().toLowerCase();
    var first = f.first_name.value.trim(), last = f.last_name.value.trim();
    var c = byCode[cCode.value] || match(cInput.value);
    if (!first || !last || !c || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { say(d.invalid); return; }
    closeList();

    var bot = f.website.value !== '' || now() - openedAt < 2500;
    var btn = form.querySelector('.sp__send');
    btn.disabled = true; say('');

    var ft = get(localStorage, FT) || {}, lt = get(localStorage, LT) || {};
    var attrib = Object.assign({ signup_source: d.source, signup_trigger: trigger, signup_page: location.pathname, signup_market: d.market, signup_locale: lang },
      prefixed(ft, 'signup_first_'), prefixed(lt, 'signup_last_'));

    var send = bot ? Promise.resolve() : post('events', {
      data: { type: 'event', attributes: {
        properties: Object.assign({ country_code: c.code, country: english.of(c.code), page_url: location.origin + location.pathname }, attrib),
        metric: { data: { type: 'metric', attributes: { name: d.metric } } },
        profile: { data: { type: 'profile', attributes: {
          email: email, first_name: first, last_name: last,
          locale: lang + '-' + c.code,
          location: { country: english.of(c.code) },
          properties: Object.assign({ 'Country Select': english.of(c.code) }, attrib) /* the email templates' location branches read this */
        } } }
      } }
    }).then(function () {
      return post('subscriptions', {
        data: { type: 'subscription', attributes: {
          custom_source: d.source,
          profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
        }, relationships: { list: { data: { type: 'list', id: d.list } } } }
      });
    });

    send.then(function () {
      if (!bot) {
        state.signedUp = true;
        if (!TEST) set(localStorage, KEY, state);
        try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (err) {}
        if (!TEST) publish('signup_postcard_submit', { country: c.code });
      }
      var t = root.querySelector('[data-sp-thanks-title]');
      if (t && d.thanksName) t.textContent = d.thanksName.replace('__NAME__', first);
      sequence();
    }).catch(function () { btn.disabled = false; say(d.error); });
  });

  function sequence() {
    phase = 'sending';
    tilt.style.setProperty('--rx', '0deg'); tilt.style.setProperty('--ry', '0deg');
    var lead = desktop.matches || reduced ? 0 : 780;
    if (lead) root.classList.add('is-card');
    later(function () { root.classList.add('is-stamped'); }, lead);
    later(function () { root.classList.add('is-sent'); }, lead + (reduced ? 500 : 950));
    later(function () { phase = 'thanks'; root.classList.add('is-thanks'); }, lead + (reduced ? 900 : 2100));
    later(lift, lead + (reduced ? 2600 : 3500));
  }
})();
